module.exports = __webpack_public_path__ + "static/media/ic_recommend.183b6dc5.svg";